import { createStyles } from 'antd-style'

export const useStyles = createStyles(
  (
    { token },
    props: { transform?: string; transformOrigin?: string; dragging?: boolean }
  ) => ({
    wrapper: {
      marginTop: 16,
      width: '100%',
      height: '100%',
      position: 'relative'
    },
    card: {
      backgroundColor: token.colorBgContainerDisabled,
      height: '70vh',
      position: 'static',
      overflow: 'hidden'
    },
    chartContainer: {
      width: '100%',
      height: '100%',
      position: 'relative',
      justifyContent: 'center',
      display: 'flex',
      alignItems: 'center',
      cursor: props.dragging ? 'grabbing' : 'grab'
    },
    chart: {
      transform: props.transform,
      transformOrigin: props.transformOrigin,
      transition: 'transform .1s ease-out'
    }
  })
)
